// https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/theme/src/foundations/breakpoints.ts

export const breakpoints = {
  xs: '24em',
}
